import type { LucideIcon } from 'lucide-react';
import { House, Receipt, ShoppingBag, Clock, Package, LayoutGrid } from 'lucide-react';

export type NavBadge = 'cart' | 'queued' | 'orders' | 'held' | null;

export interface NavItem {
    to: string;
    icon: LucideIcon;
    labelKey: 'nav.home' | 'nav.transactions' | 'nav.sell' | 'nav.held' | 'nav.orders' | 'nav.more';
    badge: NavBadge;
    /** The raised centre action on the phone tab bar */
    primary?: boolean;
    /** Landscape rail only; the phone tab bar stays at five items */
    railOnly?: boolean;
}

/** Destinations shared by the phone tab bar and the landscape rail (the rail adds Ditahan). */
export const NAV_ITEMS: NavItem[] = [
    { to: '/dashboard', icon: House, labelKey: 'nav.home', badge: null },
    { to: '/transactions', icon: Receipt, labelKey: 'nav.transactions', badge: 'queued' },
    { to: '/catalog', icon: ShoppingBag, labelKey: 'nav.sell', badge: 'cart', primary: true },
    { to: '/held-carts', icon: Clock, labelKey: 'nav.held', badge: 'held', railOnly: true },
    { to: '/online-orders', icon: Package, labelKey: 'nav.orders', badge: 'orders' },
    { to: '/settings', icon: LayoutGrid, labelKey: 'nav.more', badge: null },
];

/** Routes that belong to a tab without being its path (so the tab stays lit). */
export const NAV_ALIASES: Record<string, string> = {
    '/cart': '/catalog',
    '/checkout': '/catalog',
    '/reports/daily': '/settings',
    '/topup': '/settings',
    '/attendance': '/settings',
    '/petty-cash': '/settings',
    '/reimbursement': '/settings',
    '/stock-request': '/settings',
    '/stock-opname': '/settings',
    '/notifications': '/settings',
};
